export const namespace = 'settings.custom_inspections.index';
